export default "__VITE_ASSET__RuCz77AA__"